import { mapGetters } from "vuex";

export default {
    name: "GuidesTextBlock",
    props: {},
    emits: [],
    components: {},
    setup() {},
    data() {
        return {}
    },
    created() {},
    mounted() {},
    watch: {},
    computed: {
        ...mapGetters({
            content: "guides/content",
        }),
    },
    methods: {}
}
